import axios from '../../../axios';
import ICallLogSearch from '../types/ICallLogSearch';
import IExtensionMappingDTO from '../types/IExtensionMappingDTO';
import ISharePhoneNumber from '../types/ISharePhoneNumber';
import ITelnyx from '../types/ITelnyx';
import ITwilio from '../types/ITwilio';
import IWorkForceUser from '../types/IWorkForceUser';
import IZoomRefresh from '../types/IZoomRefresh';

const url = '/communicationservice/api/';

export const refreshAccounts = () => axios.get(`${url}communication/refresh`);

export const refreshAccountsWithApi = () => axios.get(`${url}telnyx/refresh`);

export const getWorkspacePhoneCreditLogs = (page = 0, size = 50, workspaceId: string) =>
  axios.get(
    `${url}workspace-phone-credit/logs?page=${page}&size=${size}&workspaceId=${workspaceId}`
  );

export const sharePhoneNumber = (sharePhoneNumberPayload: ISharePhoneNumber) =>
  axios.post(`${url}communication/share-phone-number`, sharePhoneNumberPayload);

export const getWorkspaceCommunicationCredits = () =>
  axios.get(`${url}workspace-phone-credit/current-workspace`);

export const addTwilioAccount = (twilioPayload: ITwilio) =>
  axios.post(`${url}twilio`, twilioPayload);

export const addTelnyxAccount = (telnyxPayload: ITelnyx) =>
  axios.post(`${url}telnyx/add`, telnyxPayload);

export const getRingCentralAuthUrl = () => axios.get(`${url}ringcentral-auth-url`);

export const getZoomAuthUrl = () => axios.get(`${url}zoom/zoom-auth-url`);

export const logOutZoom = () => axios.get(`https://zoom.us/logout`);

export const refreshZoom = (accountIds: IZoomRefresh) =>
  axios.post(`${url}zoom/zoom-refresh-account`, accountIds);

export const deleteCommunicationAccount = (id: string) =>
  axios.delete(`${url}communication/accounts/${id}`);

export const getCommunicationLogs = (page: number) => axios.get(`${url}communication-log/${page}`);

export const getCommunicationCallLogs = (page: number) =>
  axios.get(`${url}communication-log/call/${page}`);

export const searchCommunicationCallLogs = (callLogPayload: ICallLogSearch) =>
  axios.post(`${url}communication-log/search/call-logs`, callLogPayload);

export const getCurrentUserCommunicationAccountOwnerId = () =>
  axios.post(`${url}communication/shared-with`);

export const createExtensionMapping = (extensionMappingDTO: IExtensionMappingDTO) =>
  axios.post(`${url}communication-log/extension/createMapping`, extensionMappingDTO);

export const deleteExtensionMapping = (
  accountId: string,
  extensionMappingDTO: IExtensionMappingDTO
) => axios.put(`${url}communication-log/extension/deleteMapping/${accountId}`, extensionMappingDTO);

export const fetchExtensionMapping = () =>
  axios.get(`${url}communication-log/extension/getMappings`);

export const getCallLogsBasedOnPhoneNumber = (phoneNumber: string, page: number) =>
  axios.get(`${url}communication/callLogs/${phoneNumber}/${page}`);

export const getCallLogTranscript = (zoomTranscriptURL: string, accountID: string) =>
  axios.get(`${url}communication/fetch-transcript-logs`, {
    params: { zoomTranscriptURL, accountID },
  });

export const removeWorkForceUser = (payload: IWorkForceUser) =>
  axios.put(`${url}communication/remove-assigned-user`, payload);
